export const NEW_LOCATION_ID_PREFIX = 'new-location-id';

export const DEFAULT_LOCATION = {
  id: `${NEW_LOCATION_ID_PREFIX}-0`,
  polygonGeojson: {},
  polygonSearch: false,
  state: '',
};
